import styled from 'styled-components';

export const $ShortcutTableContainer = styled.div`
  td:first-child {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }
`;
